import React, { FC, memo, useMemo } from 'react';

import { RequiredRule } from 'devextreme-react/form';
import { DropDownOptions } from 'devextreme-react/lookup';

import { AppFieldBox } from 'components/appComponents';
import { SelectBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';

type NumeclatureValue = {
  nomenclatureId: number | null;
};

type NomenclatureProps = {
  value: number | null;
  readOnly: boolean;
  onChange: (value: NumeclatureValue) => void;
  nomenclatureDataSource: DataSource;
};

const Nomenclature: FC<NomenclatureProps> = ({ value, readOnly, nomenclatureDataSource, onChange }) => {
  const searchExpr = useMemo(() => ['comment'], []);

  return (
    <AppFieldBox label="Марка*" labelTop>
      <div className="d-flex align-center">
        <SelectBox
          stylingMode="underlined"
          readOnly={readOnly}
          style={{ width: '100%' }}
          dataSource={nomenclatureDataSource}
          displayExpr="comment"
          valueExpr="id"
          searchEnabled={true}
          searchExpr={searchExpr}
          value={value}
          onItemClick={(e) => {
            onChange({
              nomenclatureId: e.itemData.id,
            });
          }}
        >
          <DropDownOptions title="Выберите марку" closeOnOutsideClick={true} showTitle={false} />
          <Validator>
            <RequiredRule message="Выберите марку" />
          </Validator>
        </SelectBox>
      </div>
    </AppFieldBox>
  );
};

export default memo(Nomenclature, (prev, next) => {
  return prev.value === next.value && prev.onChange === next.onChange;
});
